import { combineReducers } from 'redux';
import TokenReducer from './tokenReducer';
import leadFormReducer from './leadFormReducer';
import publishReducer from './publishReducer';
import surveyFormReducer from './surveyFormReducer';
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import surveyFieldDataReducer from './surveyFieldDataReducer ';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['surveyFieldData']
}
const rootReducer = combineReducers({
    TokenReducer,
    leadFormData: leadFormReducer,
    publishData: publishReducer,
    surveyData: surveyFormReducer,
    surveyFieldData: surveyFieldDataReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default persistedReducer